import useCopyToClipboard from "@/Hooks/useCopyToClipboard";

export const useShareArticle = (text) => {
    const {copied, copyFn} = useCopyToClipboard();

    const share = async () => {
        const url = location.href;

        if (navigator.share) {
            await navigator.share({title: '', text, url});
        } else {
            copyFn(url);
        }
    };

    return {share, copied};
};
